import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  showArrow?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  showArrow = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-200 rounded-full';
  const variants = {
    primary: 'bg-peoplecall text-white hover:bg-peoplecall-hover shadow-[0_4px_20px_rgba(229,64,0,0.25)] hover:shadow-[0_6px_28px_rgba(229,64,0,0.4)]',
    secondary: 'bg-zinc-900 text-white hover:bg-zinc-800',
    outline: 'border border-peoplecall text-peoplecall hover:bg-peoplecall hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-13">
      {children}
      {showArrow && <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-14" />}
    </motion.button>;
}